import {
  CalendarOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import styles from "./index.module.scss";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getProfile, updateAutoPayoutStatus } from "../api";
import moment from "moment";
import { useEffect, useState } from "react";
import { Checkbox, message } from "antd";
import { notification } from "shared/lib/antd-global";

export const ViewerHead = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [messageApi, contextHolder] = message.useMessage();
  const [autoPayoutEnabled, setAutoPayoutEnabled] = useState(false);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["profile"],
    queryFn: () => getProfile(),
  });

  useEffect(() => {
    if (!data) return;
    setAutoPayoutEnabled(data.auto_payout_enabled);
  }, [data]);

  const { mutate } = useMutation({
    mutationFn: updateAutoPayoutStatus,
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ["profile"] });
    },
    onError(error) {
      setAutoPayoutEnabled((prev) => !prev);
      notification.error({
        title:
          (error as any)?.response?.data?.message ||
          "Не удалось изменить статус авто выплаты",
      });
    },
  });

  useEffect(() => {
    if (isError) {
      messageApi.error(
        (error as any)?.response?.data?.message ||
          "An error occurred while receiving the list of acts",
      );
    }
  }, [isError, error, messageApi]);

  if (isLoading) {
    return <>{contextHolder}</>;
  }

  if (isError) {
    return (
      <div className={styles.block}>
        {contextHolder}
        {(error as any)?.response?.data?.message
          ? (error as any)?.response?.data?.message
          : "An error occurred while receiving the list of acts"}
      </div>
    );
  }

  return (
    <div className={styles.block}>
      {contextHolder}
      <div className={styles.line}>
        <div className={styles.userIcon}>
          <UserOutlined />
        </div>
        <div className={styles.infoBlock}>
          <div className={styles.infoTitle}>{t("profile.fio")}</div>
          {data?.full_name}
        </div>
      </div>

      <div className={styles.separator} />

      <div className={styles.line}>
        <div className={styles.icon}>
          <PhoneOutlined />
        </div>
        <div className={styles.infoBlock}>
          <div className={styles.infoTitle}>{t("profile.phone")}</div>
          {data?.phone}
        </div>
      </div>
      <div className={styles.line}>
        <div className={styles.icon}>
          <CalendarOutlined />
        </div>
        <div className={styles.infoBlock}>
          <div className={styles.infoTitle}>{t("profile.registered")}</div>
          {moment(data?.register_date).format("DD.MM.YYYY")}
        </div>
      </div>
      {!!data?.features?.wooppay_card_payouts && (
        <div className={styles.line}>
          <div className={styles.infoBlock}>
            <Checkbox
              checked={autoPayoutEnabled}
              onChange={(el) => {
                setAutoPayoutEnabled(el.target.checked);
                mutate(el.target.checked);
              }}
            >
              {t("profile.auto_payout")}
            </Checkbox>
          </div>
        </div>
      )}
    </div>
  );
};
